import { computed } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import { useMediaQuery } from "@vueuse/core";
import { popupState } from "./popupHook";
import { START_SURVEY } from "../store/modules/survey/actions";
import { JUMP_LOGIN } from "../store/modules/user/actions";
import { language } from "../language";
import { frontPicEnum } from "../enums";
export default function () {
  const router = useRouter();
  const store = useStore();
  const config = computed(() => store.state.survey.config);
  const questionList = computed(() => store.state.survey.questionList);
  const translate = computed(() => store.state.survey.translate);
  const gameName = computed(() => store.state.survey.gameName);
  const cover = computed(() => store.state.survey.cover);
  const title = computed(() => translate.value[cover.value?.title?.id]);
  const hasAward = computed(() => +store.state.survey.sendType !== 2); // 问卷作答后是否有发奖
  const isFullCover = computed(
    () => store.state.survey.frontPicType == frontPicEnum.fullScreen
  );
  const coverPicList = computed(() => store.state.survey.coverPicList);
  const hasCoverAward = computed(
    () => store.state.survey.coverAwardList.length > 0
  ); // 封面是否有奖励
  const description = computed(
    () => translate.value[cover.value?.description?.id]
  );
  const isPo = useMediaQuery("(orientation:portrait)");
  const coverPic = computed(() => config.value?.FRONT_PIC_P_URL);
  const getCurCoverPic = computed(() => {
    let defaultPic =
      "https://cdnimages.awselbcombine.com/public_images/one_image/2024/01/17061826595445.jpg";
    if (!isFullCover.value) {
      return defaultPic;
    }
    if (isPo.value) {
      return coverPicList.value.type_v || defaultPic;
    }
    return coverPicList.value.type_h || defaultPic;
  });
  const coverFontColor = computed(() => store.state.survey.coverFontColor);
  const start = () => {
    // 未开始
    if (!store.state.survey.canSurveyTimeStart) {
      popupState.tips = language.getTextByKey("unStart");
      return;
    }
    // 已结束
    if (store.state.survey.isSurveyEnd) {
      popupState.tips = language.getTextByKey("end");
      return;
    }
    // 链接无问卷id或者接口无返回内容
    if (!window.id || !questionList.value.length) {
      popupState.tips = language.getTextByKey("end");
      return;
    }
    // 未登录但需要登陆要求
    if (!store.state.user.isLogin && +store.state.survey.loginLimit) {
      // 2023/01/18：锶雅：未登陆直接跳登陆页即可
      store.dispatch(`user/${JUMP_LOGIN}`);
      return;
    }
    // 是否已经作答
    if (store.state.survey.isAnswer && store.state.survey.isAward) {
      popupState.tips = language.getTextByKey("isAnswer");
      return;
    }
    // 处理开始问卷
    store.dispatch(`survey/${START_SURVEY}`);
    router.push({
      name: "question",
    });
  };
  return {
    start,
    title,
    isPo,
    description,
    coverPic,
    gameName,
    hasAward,
    hasCoverAward,
    isFullCover,
    getCurCoverPic,
    coverFontColor,
  };
}
